import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconDoubleArrow = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--double-arrow")} iconColor={color} size={size} width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.126.879a.5.5 0 0 1 .748 0L8.427 3.75a.5.5 0 0 1-.374.832H2.947a.5.5 0 0 1-.374-.832L5.126.88zM5.126 9.205a.5.5 0 0 0 .748 0l2.553-2.873a.5.5 0 0 0-.374-.832H2.947a.5.5 0 0 0-.374.832l2.553 2.873z" fill="currentColor"/>
  </IconWrapper>
)
